import { Link } from 'react-router-dom';
import { FileQuestion } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { PageHeader } from '@/components/page-header';

/**
 * BL-115: unbekannte URLs redirecteten bisher stumm auf "/" — ein Tippfehler
 * in der Adresszeile oder ein toter Link landete kommentarlos im Dashboard,
 * ohne dass erkennbar war, dass die eigentliche Ziel-Seite nicht existiert.
 */
export function NotFoundPage() {
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Fehler" title="Seite nicht gefunden" />
      <Card>
        <CardContent className="flex flex-col items-center gap-3 p-10 text-center">
          <FileQuestion className="h-10 w-10 text-ink-muted" />
          <p className="text-sm text-ink-muted">
            Für diese Adresse gibt es keine Seite. Prüfe den Link oder gehe zurück zum Dashboard.
          </p>
          <Link to="/" className="text-sm text-avameo-primary underline hover:no-underline">
            Zum Dashboard
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
